<template>
  <div class="auth-page">
    <div class="auth-hero">
      <img class="auth-logo" src="~@/assets/image/logo.png" alt="logo">
    </div>

    <div class="auth-title">找回密码</div>

    <div class="auth-form forgot-form">
      <div class="field-group">
        <div class="field-label">身份证号</div>
        <input v-model.trim="form.idCard" class="auth-input" type="text" placeholder="请输入身份证号">
      </div>

      <div class="field-group">
        <div class="field-label">手机号</div>
        <input v-model.trim="form.phone" class="auth-input" type="tel" placeholder="请输入手机号">
      </div>

      <div class="field-group">
        <div class="field-label">新密码</div>
        <input v-model.trim="form.password" class="auth-input" type="password" placeholder="请输入新密码">
      </div>

      <div class="field-group">
        <div class="field-label">新密码</div>
        <input v-model.trim="confirmPassword" class="auth-input" type="password" placeholder="请再次输入新密码">
      </div>

      <button class="primary-btn" type="button" :disabled="loading" @click="handleSubmit">
        {{ loading ? '提交中...' : '提交找回' }}
      </button>

      <button class="text-link back-login" type="button" @click="goLogin">
        <van-icon name="replay" />
        返回登录
      </button>
    </div>
  </div>
</template>

<script>
import { forgotPassword } from '@/api/index.js'

export default {
  data() {
    return {
      loading: false,
      confirmPassword: '',
      form: {
        phone: '',
        idCard: '',
        password: ''
      }
    }
  },
  methods: {
    goLogin() {
      this.$router.push('/login')
    },
    handleSubmit() {
      if (!this.form.idCard) {
        this.$toast('请输入身份证号')
        return
      }
      if (!this.form.phone) {
        this.$toast('请输入手机号')
        return
      }
      if (!this.form.password) {
        this.$toast('请输入新密码')
        return
      }
      if (this.form.password !== this.confirmPassword) {
        this.$toast('两次输入的新密码不一致')
        return
      }

      this.loading = true
      forgotPassword(this.form).then(() => {
        this.$toast.success('密码已重置')
        this.goLogin()
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import './style.scss';
</style>
